import { useT } from '@/i18n';
import { ROOM_STYLE, type RoomKey } from '@/lib/rooms';
import { cx } from './cx';

export const RoomTag = ({ room, className = '' }: { room: RoomKey; className?: string }) => {
  const t = useT();
  return (
    <span className={cx('inline-flex items-center rounded-pill px-2.5 py-0.5 text-caption font-extrabold', ROOM_STYLE[room].tag, className)}>
      {t(`room.${room}`)}
    </span>
  );
};
